import styled from 'styled-components';
import {FlexCenter, interceptProps} from '@/styled-components';
import {palette} from '@/styles/palette';

export const ToolboxItem = styled(FlexCenter)
  .withConfig({
    shouldForwardProp: interceptProps([
      'active',
      'highlight',
      'isFirstItem',
      'isLastItem',
    ]),
  })
  .attrs({
    as: 'button',
  })<{
  active?: boolean;
  highlight?: boolean;
  isFirstItem?: boolean;
  isLastItem?: boolean;
}>`
  position: relative;
  flex-direction: column;
  width: 42px;
  height: 42px;
  border: none;
  border-bottom: solid 1px ${palette.gray200};
  ${({isFirstItem}) =>
    isFirstItem &&
    `border-top-right-radius: 3px;
  border-top-left-radius: 3px;`}
  ${({isLastItem}) =>
    isLastItem &&
    `border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
    border-bottom: 0;`}
  cursor: pointer;
  background-color: ${palette.white};
  &:disabled {
    cursor: default;
    & svg {
      color: ${palette.disabled};
    }
  }
  &.hover:hover {
    background-color: ${palette.teal200};
    & svg {
      color: ${palette.white};
    }
  }
  ${({active}) =>
    active &&
    `
    background-color: ${palette.teal200};
    & svg {
      color: ${palette.white};
    }
  `}
  ${({highlight}) =>
    highlight &&
    `
    box-shadow: 0px 0px 0px 4px rgba(43, 117, 253, 0.50);
  `}
`;

export const ButtonGroup = styled.div`
  border: solid 1px ${palette.gray200};
  border-radius: 3px;
  box-shadow: 0px 4px 10px 0px #00000026;
  pointer-events: auto;
`;
